import React from "react";
import ReactDom from "react-dom";
import PromoListingApp from "./PromoListingApp.jsx";

export function renderPromoListing() {
  document.querySelectorAll(".js-promo-listing-mount").forEach((mount, i) => {
    const dictionary = JSON.parse(mount.dataset.dictionary) || null;
    const query = JSON.parse(mount.dataset.query) || {};
    const dataModel = JSON.parse(mount.dataset.model);

    ReactDom.render(
      <PromoListingApp
        dictionary={dictionary}
        query={query}
        id={`promo-listing-${i}`}
        {...dataModel}
      />,
      mount,
    );
  });
}
